import { useState } from "react";

// 端末種別（UA・クライアントヒント）のみでモバイル判定する。
// ウィンドウ幅やタッチの有無は判定に使わない。
// （旧実装の「タッチ対応 かつ 幅800px以下」判定は、タッチ対応ノートPCを
//   狭いウィンドウで使っただけでモバイル扱いになる誤判定源だったため廃止）
function checkMobile() {
  const ua = navigator.userAgent;
  const regex =
    /iphone;|(ipad;)|(android|nokia|blackberry|bb10;).+mobile|android.+fennec|opera.+mobi|windows phone|symbianos/i;
  const isMobileByUa = regex.test(ua);
  // iPadOS 13+ はデスクトップ UA を名乗るため platform + タッチ点数で判定する
  const isIpad =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  // Android タブレットは UA に "Mobile" を含まない
  const isAndroidTablet = /android/i.test(ua) && !/mobile/i.test(ua);
  const isMobileByClientHint = Boolean(
    navigator.userAgentData && navigator.userAgentData.mobile
  );
  return Boolean(
    isMobileByClientHint || isMobileByUa || isIpad || isAndroidTablet
  );
}

export const useMobile = () => {
  // 端末種別は実行中に変わらないため、初回に一度だけ判定する
  const [isMobile] = useState(() => checkMobile());
  return { isMobile };
};
